<template>
  <div class="app-container">
    <GooglePlayBanner />
    <router-view></router-view>
    <AlertToasts /> 
    <GlobalToast />     
  </div>
</template>

<script>
import AlertToasts from "./views/alert-toasts/AlertToasts.vue";
import GooglePlayBanner from "./views/google-play/GooglePlayBanner.vue";
import './style.css'
import GlobalToast from "./views/common/toasts/global-toast.vue";
export default {
  components: { AlertToasts, GooglePlayBanner, GlobalToast },
  setup() {
    return {};
  },
};
</script>

